// 公棚API
import http from './api'
import Vue from 'vue'
export default{
  // 赛事列表
  getShedGames(params){
    return http.get(Vue,'/xxx-cms/pc/shed/games', params)
  },
  // 公棚列表
  getShedHosts(params){
    return http.get(Vue,'/xxx-cms/pc/shed/hosts', params)
  },
  // 公棚介绍
  getShedIntroduce(params){
    return http.get(Vue,'/xxx-cms/pc/shed/introduce', params)
  },
  // 荣誉殿堂列表
  getListHallHonors(params){
    return http.get(Vue,'/xxx-cms/pc/shed/listHallHonors', params)
  },
  // 六信工程
  getShedLiuxin(params){
    return http.get(Vue,'/xxx-cms/pc/shed/liuxin', params)
  },
  // 最新动态
  getShedNews(params){
    return http.get(Vue,'/xxx-cms/pc/shed/news', params)
  },
  // 
  // 文章详情
  getArticleID(params){
    return http.get(Vue,`/xxx-cms/pc/article/${params}`)
  },


  // 赛事详情 ********************************************************************
  // 历史预订记录
  getListHistory(params){
    return http.get(Vue,'/xxx-cms/pc/gameBook/listHistory', params)
  },
  // 赛事章程详情
  getGameInfo(params){
    return http.get(Vue,'/xxx-cms/pc/game/info', params)
  },
  // 入棚照
  getPhotos(params){
    return http.get(Vue,'/xxx-cms/pc/enterShed/photos', params)
  },
  // 探视视频
  getVideos(params){
    return http.get(Vue,'/xxx-cms/pc/visitPay/videos', params)
  },
   // 获取视频播放地址
  getVodPlayUrl(params){
    return http.get(Vue,'/xxx-cms/pc/visitPay/getVodPlayUrl', params)
  },
  // 探视缴费初始化
  getVisitInit(params){
    return http.get(Vue,'/xxx-cms/pc/visitPay/init', params)
  },
  // 检查缴费资格
  getCheck(params){
    return http.get(Vue,'/xxx-cms/pc/visitPay/check', params)
  },
  // 缴费初始化
  getCommitInit(params){
    return http.get(Vue,'/xxx-cms/pc/visitPay/commitInit', params)
  },
  // 图片上传 /xxx-cms/image/upload
  uploadImg(params){
    return http.postForm(Vue,'/xxx-cms/image/upload',params)
  },
  // 提交缴费信息
  getVerifyCommit(params){
    return http.postJson(Vue,'/xxx-cms/pc/visitPay/commit', params)
  },
  // 选择探视方式
  getVerifySelect(params){
    return http.postJson(Vue,'/xxx-cms/pc/visitPay/select', params)
  },
  // 查询酒店信息
  getHotelInfo(params){
    return http.get(Vue,'/xxx-cms/pc/visitPay/getHotelInfo', params)
  },
  // 编辑酒店信息
  getEditHotelInfo(params){
    return http.postJson(Vue,'/xxx-cms/pc/visitPay/editHotelInfo', params)
  },
  // 探视公示名单
  getMembers(params){
    return http.get(Vue,'/xxx-cms/pc/visitPay/members', params)
  },
  // 赛事预订 ***********************************************************************
  // 提交预订
  getReserveSubmit(params){
    return http.postJson(Vue,'/xxx-cms/pc/gameBook/submit', params)
  },
  // 重新提交
  getReserveReSubmit(params){
    return http.postJson(Vue,'/xxx-cms/pc/gameBook/reSubmit', params)
  },
  // 预订详情（无脱敏）
  getInfo(params){
    return http.get(Vue,'/xxx-cms/pc/gameBook/info', params)
  },
  // 赛事预订初始化
  getInit(params){
    return http.get(Vue,'/xxx-cms/pc/gameBook/init', params)
  },
  // 预订详情（脱敏）
  getDesInfo(params){
    return http.get(Vue,'/xxx-cms/pc/gameBook/des/info', params)
  },
  // 根据ID查询手机号
  getUserMobile(params){
    return http.get(Vue,'/xxx-cms/pc/gameBook/getUserMobile', params)
  },
  // 精英赛预订 ***********************************************************************
  // 校验精英赛预订资格
  getEliteCheck(params){
    return http.get(Vue,'/xxx-cms/pc/classicBook/check', params)
  },
  // 提交预订
  getEliteSubmit(params){
    return http.postJson(Vue,'/xxx-cms/pc/classicBook/submit', params)
  },
  // 重新提交
  getEliteReSubmit(params){
    return http.postJson(Vue,'/xxx-cms/pc/classicBook/reSubmit', params)
  },
  // 预订详情（无脱敏）
  getEliteInfo(params){
    return http.get(Vue,'/xxx-cms/pc/classicBook/getInfo', params)
  },
  // 精英赛预订初始化
  getEliteInit(params){
    return http.get(Vue,'/xxx-cms/pc/classicBook/init', params)
  },
  // 预订详情（脱敏）
  getEliteDesInfo(params){
    return http.get(Vue,'/xxx-cms/pc/classicBook/getDesInfo', params)
  },
  // *************************
  // 精英赛
  // 获取确认详情
  getConfirmOrder(params){
    return http.get(Vue,'/xxx-cms/pc/classic/getConfirmOrder', params)
  },
  // 初始化
  getClassicInit(params){
    return http.get(Vue,'/xxx-cms/pc/classic/init', params)
  },
  // 待确认页面初始化
  getInitWaitConfirm(params){
    return http.get(Vue,'/xxx-cms/pc/classic/initWaitConfirm', params)
  },
  // 公示名单
  getListConfirmMember(params){
    return http.get(Vue,'/xxx-cms/pc/classic/listConfirmMember', params)
  },
  // 待确认赛鸽列表
  getListWaitConfirmPigeons(params){
    return http.get(Vue,'/xxx-cms/pc/classic/listWaitConfirmPigeons', params)
  },
  // 提交
  pistSubmitConfirm(params){
    return http.postJson(Vue,'/xxx-cms/pc/classic/submitConfirm', params)
  },
  // ****************************
  // 竞赛
  // 校验是否缴纳参赛费
  getCheckPay(params){
    return http.get(Vue,'/xxx-cms/pc/king/checkPay', params)
  },
  // 技能赛列表
  getKingGames(params){
    return http.get(Vue,'/xxx-cms/pc/king/games', params)
  },
  // 报名详细信息
  getUserSpecifyInfo(params){
    return http.get(Vue,'/xxx-cms/pc/king/getUserSpecifyInfo', params)
  },
  // 已报名列表
  getListUserSpecify(params){
    return http.get(Vue,'/xxx-cms/pc/king/listUserSpecify', params)
  },
  // 待指定分组列表
  pistListWaitSpecifyGroup(params){
    return http.postJson(Vue,'/xxx-cms/pc/king/listWaitSpecifyGroup', params)
  },
  // 待指定赛鸽列表
  getListWaitSpecifyPigeon(params){
    return http.get(Vue,'/xxx-cms/pc/king/listWaitSpecifyPigeon', params)
  },
  // 提交指定
  pistSubmitSpecify(params){
    return http.postJson(Vue,'/xxx-cms/pc/king/submitSpecify', params)
  },
  // 竞赛指定查询 
  getSpecifyRecord(params){
    return http.get(Vue,'/xxx-cms/pc/king/getSpecifyRecord', params)
  },
  // 查询截止时间
  getDeadline(params){
    return http.get(Vue,'/xxx-cms/pc/king/getDeadline', params)
  },
  // 竞赛查询列表
  listShowGame(params){
    return http.get(Vue,'/xxx-cms/pc/king/listShowGame', params)
  },
  // ************************************
  // 团体赛
  // 校验分组资格
  getTeamCheck(params){
    return http.get(Vue,'/xxx-cms/pc/team/check', params)
  },
  // 团体赛列表
  getTeamGames(params){
    return http.get(Vue,'/xxx-cms/pc/team/games', params)
  },
  // 团体分组初始化
  getTeamInitGroup(params){
    return http.get(Vue,'/xxx-cms/pc/team/initGroup', params)
  },
  // 提交分组
  pistSubmitGroup(params){
    return http.postJson(Vue,'/xxx-cms/pc/team/submitGroup', params)
  },
  // 团体分组公示名单
  getListGroupMember(params){
    return http.get(Vue,'/xxx-cms/pc/team/listGroupMember', params)
  },
  // *******************************************
  // 加站赛
  // 报名详情
  getExtraBook(params){
    return http.get(Vue,'/xxx-cms/pc/extra/getExtraBook', params)
  },
  // 初始化
  getExtraInit(params){
    return http.get(Vue,'/xxx-cms/pc/extra/init', params)
  },
  // 初始化待报名赛鸽列表
  getInitExtraBook(params){
    return http.get(Vue,'/xxx-cms/pc/extra/initExtraBook', params)
  },
  // 加站赛公示名单
  getListExtraBookMember(params){
    return http.get(Vue,'/xxx-cms/pc/extra/listExtraBookMember', params)
  },
  // 提交加站赛预订
  pistSubmitExtraBook(params){
    return http.postJson(Vue,'/xxx-cms/pc/extra/submitExtraBook', params)
  },
  // ****************************************
  // 获奖鸽
  getAwardsPigeonList(params){
    return http.get(Vue,'/xxx-cms/pc/awardsPigeon/list', params)
  },
  // 获取赛事列表
  getAwardsPigeonGames(params){
    return http.get(Vue,'/xxx-cms/pc/awardsPigeon/games', params)
  },
  // ****************************************
  // 成绩查询
  // 上笼赛鸽列表
  getCollects(params){
    return http.get(Vue,'/xxx-cms/pc/score/collects', params)
  },
  // 赛程列表
  getGames(params){
    return http.get(Vue,'/xxx-cms/pc/score/games', params)
  },
  // 成绩排名
  getRank(params){
    return http.get(Vue,'/xxx-cms/pc/score/rank', params)
  },
  // 赛程概要信息
  getSummary(params){
    return http.get(Vue,'/xxx-cms/pc/score/summary', params)
  },
  // *******************************************
  // 我的账户
  // 查询账户
  getMyAcct(params){
    return http.get(Vue,'/xxx-cms/pc/myAcct/get', params)
  },
  // 提交账户
  postMyAcct(params){
    return http.postJson(Vue,'/xxx-cms/pc/myAcct/submit', params)
  },
  // 获取隶属银行
  getBelongBank(params){
    return http.get(Vue,'/xxx-cms/pc/myAcct/getBelongBank', params)
  },
}


// WEBPACK FOOTER //
// ./src/api/shed-index.js